import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PointExchangeAPI from "../../../../../apiConfig/PointExchangeAPI";
import { Status } from "../../../../../redux/constant";

const initialState = {
  convertPartnerRates: {},
  status: Status.INITIAL,
  errorMessage: null,
};

export const fetchAsyncConvertPartnerRates = createAsyncThunk(
  "convertPartnerRates/fetchAsyncConvertPartnerRates",
  async ({ source, target }, { rejectWithValue }) => {
    try {
      const response = await PointExchangeAPI.get(`/rates/${source}/${target}`);
      return response.data;
    } catch (err) {
      if (err.response) {
        return rejectWithValue({
          status: err.response.status,
          data: err.response.data,
        });
      }
      return rejectWithValue({
        status: "",
        data: err.message,
      });
    }
  },
);

const ConvertPartnerRatesSlice = createSlice({
  name: "convertPartnerRates",
  initialState,
  reducers: {
    resetConvertPartnerRates: state => {
      state.convertPartnerRates = [];
      state.status = Status.INITIAL;
      state.errorMessage = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAsyncConvertPartnerRates.pending, state => {
        state.errorMessage = null;
        state.status = Status.LOADING;
      })
      .addCase(
        fetchAsyncConvertPartnerRates.fulfilled,
        (state, { payload }) => {
          state.convertPartnerRates = payload;
          state.status = Status.LOADED;
        },
      )
      .addCase(fetchAsyncConvertPartnerRates.rejected, (state, { payload }) => {
        if (payload === undefined) {
          state.status = Status.ERROR;
          return;
        }
        state.errorMessage = payload.data;
        state.status = Status.ERROR;
      });
  },
});

export const { resetConvertPartnerRates } = ConvertPartnerRatesSlice.actions;

export default ConvertPartnerRatesSlice.reducer;
